import(/* webpackMode: "eager" */ "/tutearn/app/globals.css");
import(/* webpackMode: "eager" */ "/tutearn/components/sentry-provider.tsx");
import(/* webpackMode: "eager" */ "/tutearn/components/theme-provider.tsx");
import(/* webpackMode: "eager" */ "/tutearn/components/ui/toaster.tsx");
import(/* webpackMode: "eager" */ "/tutearn/components/ui/tooltip.tsx")